const state = () => ({
  goodsList: [],
  currentIndex: -1,
  isFormHangOrder: false,
})
const getters = {
  goodsList: (state) => state.goodsList,
  currentIndex: (state) => state.currentIndex,
  isFormHangOrder: (state) => state.isFormHangOrder,
}
const mutations = {
  setGoodsList(state, goodsList) {
    state.goodsList = goodsList
  },
  setCurrentIndex(state, currentIndex) {
    state.currentIndex = currentIndex
  },
  setIsFormHangOrder(state, isFormHangOrder) {
    state.isFormHangOrder = isFormHangOrder
  },
}
const actions = {
  setGoodsList({ commit }, goodsList) {
    commit('setGoodsList', goodsList)
    if (goodsList.length == 0) {
      commit('setCurrentIndex', -1)
    }
  },
  setCurrentIndex({ commit }, currentIndex) {
    commit('setCurrentIndex', currentIndex)
  },
  setIsFormHangOrder({ commit }, isFormHangOrder) {
    commit('setIsFormHangOrder', isFormHangOrder)
  },
}
export default { state, getters, mutations, actions }
